// Helpers for deciding whether two document URLs point at the SAME document.
//
// The viewer is handed S3 pre-signed URLs. A pre-signed URL is not stable: every
// time it is minted for the same object it carries a fresh signature and expiry
// in its query string, so the URL *string* changes while the *document* does not.
// Treating that churn as "a different document" reloads the PDF and throws the
// reviewer back to page 1 mid-review (Trello IYmLT1Pl).
//
// The object identity lives entirely in the URL path — bucket host + key — so
// dropping the query string (and any fragment) yields a key that is stable across
// re-signings of the same object.

/**
 * Derive a stable identity key for a document URL by discarding the parts that
 * change on every re-signing (query string, fragment).
 *
 * @param {string} url - an absolute URL, or a bare path
 * @returns {string|null} stable key, or null when there is no URL yet
 */
export const stableDocumentKeyFromUrl = (url) => {
    if (!url) return null;
    try {
        const parsed = new URL(url);
        return `${parsed.origin}${parsed.pathname}`;
    } catch {
        // Not an absolute URL (relative path, test fixture) — strip a query string /
        // fragment manually and treat the remainder as the identity.
        return String(url).split('#')[0].split('?')[0];
    }
};

export default stableDocumentKeyFromUrl;
